<template>
  <a href="#" @click.prevent class="decoration-none text-green-400">
    <slot></slot>
  </a>
</template>
